<template>
  <div class="markets-wrapper">
    <div class="markets" v-if="markets" :class="[
                                  { 'multiple': markets.length > 1 },
                                  { 'single': markets.length === 1 },
                                  { 'empty': markets.length === 0 }]">

      <template v-if="(['TENNIS', 'SOCCER', 'BOXING', 'MMA'].indexOf(event.idfosporttype) === -1 || (['BOXING', 'MMA'].indexOf(event.idfosporttype) > 0 && !(brand_white1 || brand_translux5))) &&
        ((screenConfiguration.is2showeventsin2columns && !screenConfiguration.is2showsingleevent && !screenConfiguration.is2showoutrightevents) ||
        (screenConfiguration.is2showsingleevent && forcenonbig3 !== true))">
        <template v-for="column in big3columns">
          <big3market v-if="column === 'PS'" :market="pointsMarket" :showheader="showheader" :big3markettype="'PS'"></big3market>
          <big3market v-else-if="column === 'TP'" :market="totalMarket" :showheader="showheader" :big3markettype="'TP'"></big3market>
          <big3market v-else-if="column === 'ML'" :market="moneyMarket" :showheader="showheader" :big3markettype="'ML'"></big3market>
        </template>
      </template>

      <template v-else-if="(brand_white1 || brand_translux5) && ['TENNIS', 'SOCCER', 'BOXING', 'MMA'].indexOf(event.idfosporttype) > -1 && (screenConfiguration.is2showeventsin2columns || screenConfiguration.is2showsingleevent) && nonBig3TwoColumnsHadMarket">
        <template v-for="hadvalue in ['H', 'D', 'A']" v-if="event.idfosporttype === 'SOCCER' && brand_white1">
          <div class="market selection-wrapper had" :class="hadvalue">
            <div class="header market-name-title" v-if="showheader">
              <span v-if="hadvalue === 'A'">{{ $t('Market.Away') }}</span>
              <span v-if="hadvalue === 'D'">{{ $t('Market.Tie') }}</span>
              <span v-if="hadvalue === 'H'">{{ $t('Market.Home') }}</span>
            </div>

            <selection
              :selection="nonBig3TwoColumnsHadMarket.selections.find(sel => sel.hadvalue === hadvalue && sel.idfoselectionsuspensiontype !== 'N/O') || {}"
              :istradable="nonBig3TwoColumnsHadMarket.istradable"
              :showselectionname="false"
              :showshortselectionname="true"
              :ishad="true"></selection>
          </div>
        </template>
        <template v-for="hadvalue in ['A', 'D', 'H']" v-if="event.idfosporttype === 'SOCCER' && !brand_white1">
          <div class="market selection-wrapper had" :class="hadvalue">
            <div class="header market-name-title" v-if="showheader">
              <span v-if="hadvalue === 'A'">{{ $t('Market.Away') }}</span>
              <span v-if="hadvalue === 'D'">{{ $t('Market.Tie') }}</span>
              <span v-if="hadvalue === 'H'">{{ $t('Market.Home') }}</span>
            </div>

            <selection
              :selection="nonBig3TwoColumnsHadMarket.selections.find(sel => sel.hadvalue === hadvalue && sel.idfoselectionsuspensiontype !== 'N/O') || {}"
              :istradable="nonBig3TwoColumnsHadMarket.istradable"
              :showselectionname="false"
              :showshortselectionname="true"
              :ishad="true"></selection>
          </div>
        </template>

        <div class="market big3" v-if="event.idfosporttype === 'TENNIS' || event.idfosporttype === 'BOXING' || event.idfosporttype === 'MMA'">

          <div class="header" v-if="showheader">
            <div class="market-name">
              <h4 class="market-name-title text-overflow">{{nonBig3TwoColumnsHadMarket.name === 'Moneyline' ? $t('Market.MONEY') : nonBig3TwoColumnsHadMarket.name}}</h4>
            </div>
          </div>

          <div class="selections-container">
            <div class="selections had">
              <div class="selections">
                <div class="selection" :class="hadvalue" v-for="hadvalue in ['A', 'H']">
                  <div class="selection-column">
                    <selection
                    :selection="nonBig3TwoColumnsHadMarket.selections.find(sel => sel.hadvalue === hadvalue && sel.idfoselectionsuspensiontype !== 'N/O') || {}"
                    :istradable="nonBig3TwoColumnsHadMarket.istradable"
                    :showselectionname="false"
                    :showshortselectionname="false"
                    :ishad="true"></selection>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </template>

      <template v-else>
        <div :class="['market',
             { 'big3': market.big3markettype && ['TENNIS', 'SOCCER'].indexOf(market.idfosporttype) === -1 && !is2displayhorizontally },
             {'suspended': !market.istradable },
             'selections-x' + market.selections.length,
             {'three': market.selections.length === 3 },
             {'more-than-three-selections': market.selections.length > 3 },
             {'multi-had': isMultiHad(market) },
             { 'outright-market': event.isoutright },
             { 'had': isHadMarketsPerIDFOMarket[market.idfomarket] },
             { 'had-odd': market.hadOdd },
             { 'last-had': market.lastHad },
             { 'non-had': !isHadMarketsPerIDFOMarket[market.idfomarket] },
             { handicap: market.normalizedhandicapvalue || market.currentmatchhandicap }]"
             v-for="market in filteredMarkets"
             :key="market.idfomarket"
             :idfomarket="market.idfomarket"
             :isfrompush="(market.V !== undefined).toString()">
          <div class="header" v-if="showheader === undefined || showheader">
            <div class="market-name">
              <h4 class="market-name-title text-overflow">{{ market.name}}</h4>
            </div>
          </div>

          <span v-if="isDebug" class="debug">
            {{ market.idfomarket }}<br />
            isfrompush {{ (market.V !== undefined).toString() }}
          </span>

          <div class="selections-container">
            <!-- HAD -->
            <div v-if="market.selections && isHadMarketsPerIDFOMarket[market.idfomarket]" class="selections had">
              <div v-if="market.big3markettype && ['TENNIS', 'SOCCER'].indexOf(market.idfosporttype) === -1" :class="['selections', { 'hasdraw': market.selections.filter(sel => sel.hadvalue === 'D').length > 0 }]">
                <div class="selection" v-if="market.selections && market.selections.filter(sel => sel.hadvalue === hadvalue && sel.idfoselectionsuspensiontype !== 'N/O').length" v-for="(hadvalue, index) in ['A', 'H', 'O', 'U']" :key="index" :class="hadvalue">
                  <div class="selection-column"
                       v-for="selection in market.selections.filter(sel => sel.hadvalue === hadvalue && sel.idfoselectionsuspensiontype !== 'N/O')"
                       :key="selection.idfoselection">

                    <selection
                      :selection="selection"
                      :istradable="market.istradable"
                      :showselectionname="false || screenConfiguration.is2showsingleevent"
                      :ishad="true"></selection>
                  </div>
                </div>
              </div>
              <div v-else :class="['selections', { 'hasdraw': market.selections.filter(sel => sel.hadvalue === 'D').length > 0 }]">
                <div class="selection" v-if="market.selections && market.selections.filter(sel => sel.hadvalue === hadvalue && sel.idfoselectionsuspensiontype !== 'N/O').length" v-for="(hadvalue, index) in ['H', 'D', 'A', 'O', 'U']" :key="index" :class="hadvalue">
                  <div class="selection-column"
                       v-for="(selection) in market.selections.filter(sel => sel.hadvalue === hadvalue && sel.idfoselectionsuspensiontype !== 'N/O')"
                       :key="selection.idfoselection">

                    <selection
                      :selection="selection"
                      :istradable="market.istradable"
                      :showselectionname="true"
                      :ishad="true"></selection>
                  </div>
                </div>
              </div>
            </div>

            <!-- non HAD -->
            <div v-if="market.selections && !isHadMarketsPerIDFOMarket[market.idfomarket]" class="selections non-had">
              <!-- NON-OUTRIGHT -->
              <template v-if="!market.isoutright">
                <span class="selection"
                      v-for="selection in vue._.orderBy(market.selections, 'internalorder').filter(sel => sel.idfoselectionsuspensiontype !== 'N/O')"
                      :key="selection.idfoselection">
                  <span class="selection-column">

                    <selection
                      :selection="selection"
                      :istradable="market.istradable"
                      :showselectionname="true"
                      :ishad="false"></selection>
                  </span>
                </span>
              </template>
              <!-- OUTRIGHT -->
              <template v-else>
                <div v-for="column in outrightSelectionsColumns" :class="['selection-col', 'no' + column]">
                  <span class="selection"
                        v-for="selection in vue._.orderBy(market.selections, ['internalorder', 'currentprice', 'name']).filter(sel => sel.selectioncolumn === column && sel.idfoselectionsuspensiontype !== 'N/O')"
                        :key="selection.idfoselection">

                      <selection
                        :selection="selection"
                        :istradable="market.istradable"
                        :showselectionname="true"
                        :isoutright="true"
                        :ishad="false"></selection>
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>


    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import lib from '@/library'

  import Screen from '@/components/mixins/Screen'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import UrlParameters from '@/components/mixins/UrlParameters'
  import Brands from '@/components/mixins/Brands'

  import big3market from '@/components/bettingoffer/big3market'
  import selection from '@/components/bettingoffer/selection'

  export default {
    name: 'market',

    components: {
      selection,
      big3market
    },

    mixins: [
      Screen,
      BettingOffer,
      UrlParameters,
      Brands
    ],

    props: [
      'event',
      'markets',
      'islivepredefined',
      'is2displayhorizontally',
      'showheader',
      'forcenonbig3'
    ],

    data () {
      return {
        vue: Vue,
        clickTO: null,
        clickModal: null,
        action: null,
        selectionsPrices: {},
        expandedMarkets: {},
        panel: true,
        counter: 0
      }
    },
    methods: {
      isBig3Market (market) {
        return lib.betting.market.isBig3Market(market)
      },

      isMultiHad (market) {
        return lib.betting.market.isMultiHad(market)
      }
    },
    computed: {
      filteredMarkets () {
        if (this.markets && this.markets.length > 0) {
          let markets = this.markets.filter((market) => {
            return market.selections && market.selections.length > 0
          })

          let processedMarkets = []
          let originalIDFOEvent = markets && markets[0] && markets[0].idfoevent
          let liveEventForMarkets = this.liveEvents.find(ev => ev.idfoevent === originalIDFOEvent || ev.foeventantepost === originalIDFOEvent)
          if (liveEventForMarkets) {
            markets.forEach(mk => {
              let liveMarket = liveEventForMarkets.markets && liveEventForMarkets.markets.find(mk1 => mk.idfomarket === mk1.idfomarket)
              if (liveMarket) {
                processedMarkets.push(liveMarket)
              } else {
                processedMarkets.push(mk)
              }
            })
          } else {
            processedMarkets = markets
          }

          // Attach flags on markets that are odd and last in a row
          var hadIndex = 0
          var lastHadMarket = null
          processedMarkets.forEach((mk, index) => {
            if (this.isHadMarketsPerIDFOMarket[mk.idfomarket] && mk.selections.length < 4) {
              if (hadIndex++ % 2) {
                mk.hadOdd = true
              }
              lastHadMarket = mk
            } else {
              if (lastHadMarket) {
                lastHadMarket.lastHad = true
              }
              hadIndex = 0
            }
          })

          return processedMarkets
        } else {
          return []
        }
      },
      pointsMarket () {
        return this.filteredMarkets.find(mk => mk.big3markettype === 'PS' && mk.gameperiod === '1+')
      },
      moneyMarket () {
        return this.filteredMarkets.find(mk => mk.big3markettype === 'ML' && mk.gameperiod === '1+')
      },
      totalMarket () {
        return this.filteredMarkets.find(mk => mk.big3markettype === 'TP' && mk.gameperiod === '1+')
      },
      nonBig3TwoColumnsHadMarket () {
        return this.filteredMarkets.find(mk => {
          return (mk.idfohadtype === 'HAD' || mk.idfohadtype === 'HA') && lib.betting.market.isMoneyline(mk)
        })
      },
      screenConfiguration () {
        return store.getters['cduState/getScreenConfiguration']
      },
      appConfigPerBrand () {
        return store.getters['cduState/getAppConfigForBrand'] || {}
      },
      numOfOutrightSelectionsColumns () {
        return this.appConfigPerBrand[this.displaytemplate].numOfOutrightSelectionsColumns
      },
      displaytemplate () {
        return this.$route.params.displaytemplate || 'standard'
      },
      outrightSelectionsColumns () {
        var columns = []
        for (let i = 0; i < this.numOfOutrightSelectionsColumns; i++) {
          columns.push(i + 1)
        }

        return columns
      },
      big3columns () {
        var parambig3columnsorder = this.$route.params.big3columnsorder || '321'
        var appConfig = store.getters['cduState/getAppConfigForBrand'] || {}
        let urlParamToBig3MarketMap = appConfig.urlParamToBig3MarketMap

        var arrColumns = []
        parambig3columnsorder.split('').forEach((p, index) => {
          arrColumns.push(urlParamToBig3MarketMap[parambig3columnsorder[index]])
        })

        return arrColumns
      },
      isHadMarketsPerIDFOMarket () {
        var markets = {}
        if (this.markets && this.markets.length > 0) {
          this.markets.forEach(mk => {
            if (mk.selections) {
              markets[mk.idfomarket] = mk.selections.filter(sel => sel.hadvalue === 'H').length > 0 ||
                mk.selections.filter(sel => sel.hadvalue === 'D').length > 0 ||
                mk.selections.filter(sel => sel.hadvalue === 'A').length > 0 ||
                mk.selections.filter(sel => sel.hadvalue === 'U').length > 0
            } else {
              markets[mk.idfomarket] = false
            }
          })
        }
        return markets
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
@import '~@/css/config'
@import '~@/css/mixins'

  .markets
  .market
  .markets-wrapper
    height: 100%

  .markets
    overflow hidden


    .market
      float left
      display: flex
      flex-direction: column

      &:last-child
        margin-right: 0

      .header
        text-align center
        flex: 0 0 unit(head-height, px)
        align-center()

      .selections-container
        flex: 1 1 auto
        display: flex

        .browser-internet-explorer.browser-version-11 &
          flex: 1 1 100%

      .selections
        overflow hidden

        .selection
          border-right: solid 1px #000

          &:last-child
            border none

      &.big3
        .selections
          flex-direction: column

          .selections
            height: 100%

        .selection
          float none
          flex: 0 0 50%

          &:first-child
            border-right: none

      &.outright-market
        .header
          display: none

</style>



// WEBPACK FOOTER //
// src/components/bettingoffer/markets.vue